export default "<fa-icon *ngIf=\"showIcon\" [icon]=\"showIcon\" class=\"{{class}}\"></fa-icon>\n";